import Img1 from '../images/Activities-Image/image1.jpg'
import Img2 from '../images/Activities-Image/image2.jpg'

export const activitiesList = [
    {
        actID: '1',
        actDetail1: 'बैशाख १५ गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'थौं नेपाल सम्वत ११४३ बछलाथ्व अष्टमी बैशाख १५ गते शुक्रबा: हलिं नेवा: गुथि मृत्यु व दाह संस्कार कवं छगु ज्याझ्व न्ह्याका स्वापु कुथि पलिस्था या ज्या जुल नापं कव समिति ल्यगु ज्या पुगंकेगु ज्या जुल ।',
        actDetail4: 'बिश्वमान श्रेष्ठ कव कजि जुया दिगु कवले पवन जोशी, नारायण श्रेष्ठ, विमला श्रेष्ठ, सिताराम गोपाली, रविन्द्र शाक्य, जितमेल महर्जन, जितेन्द्र महर्जन, सुर्यदास प्रधान, मीरा जोशी जु कवया दुज ल्येगु ज्या क्वचागु जुल । वईकपिं सकसित नं यक्व यक्व लसहना नापं भिन्तुना  दु ।',
        actDetail5: 'कव कजि बिश्वमान श्रेष्ठजु या नायसुई जुगु ज्या झ्वले संरक्षक शान्तप्रकाश श्रेष्ठ, मु नाय बिनोद महर्जन, मू कव कजि सुरेश सैजु, मू दुज अक्कलदास महर्जन, गोपाल नकर्मी, अन्तराष्ट्रिय स्वापु कव कजि रमेश जोशी, ब्यापार कव कजि निमेषमान श्रेष्ठ, सम्पदा कव कजि धर्म नारायण महर्जन जुं नं ब्वती कया दिगु जुल धासा यें स्वनिग कचा, लिधंसा कचा, तिस्तुंग कचा या दुज तयसं ब्वती कागु जुल ।',
        actDetail6: '',
        actDetail7: '',
        actDetail8: '',
        actDetail9: '',
        actDetail10: '',
        actDetail11: '',
        actDetail12: '',
        actImg1: '',
        actImg2: '',
        actImg3: '',
    },
    {
        actID: '2',
        actDetail1: 'बैशाख २० गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'थौं नेपाल सम्वत ११४३ बछलाथ्व त्रयोदशी बैशाख २० गते बुधबा: हलिं नेवा: गुथि सक्व कचाया दुज भाजु कृष्णलाल श्रेष्ठ मदुगु न्यान्हु कुन्हु हलिं नेवा: गुथिं बिचा हायका ज्या झ्व न्ह्याकेगु जुल । मृत्यु संस्कार व दाह संस्कार कव या कजि बिष्णुमान श्रेष्ठ या कजिसुई जुगु थ्व ज्याझ्व या झ्वलय छें ज: यात न्हिरो दॉ नं लल्हायगु ज्या जुल । ज्या झ्वलय संरक्षक शान्त प्रकाश श्रेष्ठ, मु नाय बिनोद महर्जन, वडा अध्यक्ष राधाकृष्ण श्रेष्ठ, ल्यू छ्यान्जे सत्य नारायण श्रेष्ठ जुं वईक या ब्यक्तित्वया खंप्वंका बिचा हायका नापं चीर शान्ती जुईमा धका फ्वना निसें दुखं कपिं सकसिनॉ नुग चिया तयफयमा धका समबेदना प्वंका दिल । ज्या झ्वलय  मू दुज हरि महर्जन,  सक्व कचाया नाय धर्म भक्त मल्ल,वडा अध्यक्ष राधाकृष्ण श्रेष्ठ,  सालनदी कचाया नाय ज्ञान श्री श्रेष्ठ, एकजती बज्रयोगिनी कचाया नाय चन्दा श्रेष्ठ, रविनमान शाक्य, विमला महर्जन, बुद्दरत्न मानन्धर, बिजय बहादुर शाक्य, प्रतिभा श्रेष्ठ, गंगा श्रेष्ठ व रोशनी श्रेष्ठ जुं नं ब्वती कया दिगु जुल ।',
        actDetail4: '',
        actDetail5: '',
        actDetail6: '',
        actDetail7: '',
        actDetail8: '',
        actDetail9: '',
        actDetail10: '',
        actDetail11: '',
        actDetail12: '',
        actImg1: '',
        actImg2: '',
        actImg3: '',
    },
    {
        actID: '3',
        actDetail1: 'जेष्ठ ६ गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'थौ नेपाल सम्वत ११४३ तछलाथ्व पारु जेष्ठ ६ गते हलिं नेवा: गुथि काभ्रे जिल्ला स्तरीय ज्यासना पुचया पलॉती जुगु मुज्यॉ ज्यासना पुच पुगंकेगु ज्या जुल । ज्यासना पुच ईट्टे कचाया केन्द्रिय दुज सुवर्ण श्रेष्ठ नाय, पलॉती मिसा कचाया न्हापॉम्ह नाय समिता श्रेष्ठ न्वकु, पलॉती कचाया दुज स्यामहरी महाजू छ्यान्जे, चण्डेश्वरी मिसा कचाया नाय मनिता श्रेष्ठ दॉभरी, दुजले काभ्रे मिसा कचाया नाय बिणु कर्माचार्य, महॉकाल खरिबोट कचाया नाय मछे नारायण श्रेष्ठ, सॉगा कचाया केन्द्रिय दुज सरोज नारायण श्रेष्ठ, शारदा बतासे कचाया नाय रामकृष्ण रंजितकार, जाकीडोल कचाया नाय उमेश श्रेष्ठ, नवल कचाया नाय किशोर महर्जन, ज्यालाचिटी कचाया नाय कमला श्रेष्ठ जुया दिगु दु । वईकपिं सकसित नं यक्व यक्व लसहना नापं भिन्तुना दु । हलिं नेवा: गुथि काभ्रे जिल्लाया १८ झिंच्यागु कचा तयसं ब्वती कागु दकले न्हापॉ ईट्टे संखु कचॉ ग्वसा ग्वगु काभ्रे जिल्ला दंमुज्या ( सम्मेलन ) क्वछिना कथं थ्व ज्यासना पुच क्वछिंगु जुल ।',
        actDetail4: '',
        actDetail5: '',
        actDetail6: '',
        actDetail7: '',
        actDetail8: '',
        actDetail9: '',
        actDetail10: '',
        actDetail11: '',
        actDetail12: '',
        actImg1: '',
        actImg2: '',
        actImg3: '',
    },
    {
        actID: '4',
        actDetail1: 'जेष्ठ ६ गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'हलिं नेवाः गुथि संस्कृति कवया कजि कृष्ण प्रशाद प्रजापतिया नाय् सुई जुगु कीपुली याकः मिसा व करुणामयया प्रतिमूर्ति द्यो सुखि गछें समाज पाखें पलिस्था जुगु द्यो हान लिकया अन मतसे मेथाय् यंकुगुलीं छगु बिवादित व अति महत्वपूर्ण खय कया ZOOM ज्याझ्वः मुः छ्यान्जे अमर काजि श्रेष्ठ पाखें न्ह्यागु सभाय् ब्वति कया दिपीः गछें कचाया दुजः बुद्दिलाल महर्जन, सांस्कृतिक स्वायत्त क्षेत्रया कजि श्रीकृष्ण महर्जन, गछें कचाया दुजः नापं सुखी गछें समाजया छ्यान्जे नारायण महर्जनपाखें मुखः व संरक्षक शान्त प्रकाश श्रेष्ठ, मुः न्वकु व मुःकव कजि सुरेश सैंजु, निवर्तमान नाय् जुजु मान श्रेष्ठ, मुः नाय् बिनोद महर्जनं थःथगु खः तयादिल ज्याझ्वःले सम्पदा कव कजि धर्म नारायण महर्जन, कृषि कव कजि कृष्ण बहादुर श्रेष्ठजुनं ब्वति कया दिगु जुल सभानाय् नं थःगु खः तयादिगु क्रमय मतः वना खः पूवनके मखन लीपा फोनयाना वयकयाके बचःकया ज्याझ्वः क्वचायकिगु ज्याः जुल ।',
        actDetail4: '',
        actDetail5: '',
        actDetail6: '',
        actDetail7: '',
        actDetail8: '',
        actDetail9: '',
        actDetail10: '',
        actDetail11: '',
        actDetail12: '',
        actImg1: '',
        actImg2: '',
        actImg3: '',
    },
    {
        actID: '5',
        actDetail1: 'जेष्ठ १० गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'म्हेग जेष्ठ १० गते हलिं नेवा गुथि संस्कृति कव कजि कृष्ण प्रसाद प्रसाद प्रजापती या नायसुई सिठीनखया खंय जुमय जुगु न्यनेकने ज्याले मु न्वकु सुरेश सैजु, मु दुज अक्कल दास महर्जन, मु दुज सरल गोपाल महर्जन, कृषि कव कजि कृष्ण बहादुर श्रेष्ठ, अन्तराष्ट्रिय कव कजि रमेश जोशी, सम्पदा कव कजि धर्म नारायण महर्जन, न्हापॉम्ह मु दुज महेस्वर मानन्धर जु यात ब्वती कया दिगुलिं यक्व यक्व सुभाय । ज्या झ्व मु छ्यान्जे अमरकाजी श्रेष्ठ जुं धिस्सीलाक्क न्ह्यका दिगु जुल ।',
        actDetail4: '',
        actDetail5: '',
        actDetail6: '',
        actDetail7: '',
        actDetail8: '',
        actDetail9: '',
        actDetail10: '',
        actDetail11: '',
        actDetail12: '',
        actImg1: '',
        actImg2: '',
        actImg3: '',
    },
    {
        actID: '6',
        actDetail1: 'जेष्ठ १३ गते',
        actDetail2: 'न्हापांगु परिषद मुंज्या',
        actDetail3: 'थौ नेपाल सम्वत ११४३ तछला थ्व सप्तमी जेष्ठ १३ गते शनिबार हलिं नेवाः गुथिया न्हापांगु परिषद बैठक सिभिल होम्स तिनथाना कचाया ग्वसाले क्वचाल ।',
        actDetail4: 'सभा नाय् बिनोद महर्जन जुया दिगु ज्याझ्वः ले नेपाली राष्ट्रिय गान, नेवाः राष्ट्रिय गान  व हलिं नेवाः गुथिया राष्ट्रिय गान मे हालिगु ज्या जुल । ग्वसाखलःया नाय् श्याम प्रसाद न्हुच्छे प्रधानजुन  लसकुश न्वचु तयादिल । ',
        actDetail5: 'मुःपाहा संरक्षक शान्त प्रकाश श्रेष्ठजुन मुकुन्दा  च्याका ज्याझ्वः औपचारिक रुपं उदधाटन याना दिल कव कजिया प्रतिवेदन कथं कजीपीं क्रमश ब्यापार कव कजि निमेष मान क्षेष्ठ, सांस्कृतिक स्वायत्त क्षेत्र कव कजि श्री कृष्ण महर्जन, सम्पदा कव कजि धर्म नारायण महर्जन, उपत्यकाव्यापी सडक बिस्ता संघर्ष समिति संयोजक सुमन सायमी, स्वास्थ्य कव कजि डा. रसिला अमात्य, भाषा लिपि कव कजि तीर्थ भक्त स्याउला श्रेष्ठ, शिक्षा कव कजि जुजु भाई महर्जन, काभ्रे जिल्ला संयोजक सुवर्ण श्रेष्ठ, कृषि कव कजि कृष्ण बहादुर श्रेष्ठ, अन्तराष्ट्रिय स्वापु कव कजि रमेश कुमार जोशीजु न  थः थःगु प्रतिवेदन प्रस्तुत याना दिलः।',
        actDetail6: 'मुः दुजः अकल दास महर्जन व  लिधंसा कचाया न्वकु रामेश्वर मान डंगोलजुन थ दथःगु न्वचु तयादिल । मुः दाःभरी मीना गोपाली जुनः आर्थिक प्रतिवेदन व मुः छ्यान्जे अमर काजि श्रेष्ठ पाखें त्रैमासिक  प्रतिवेदन  प्रस्तुत याना अनुमोदन यायत  प्रस्ताव पारित जुल।',
        actDetail7: 'मुः न्वकु व मुःकव कजि सुरेश सैंजु नं थगु प्रतिवेदन ब्वंका नेनकीगु ज्या जुगु दु ।प्रतिवेदन प्रस्तुत व अनुमोदन या लागि दक्व कव कजिया प्रतिवेदन अनुमोदन जुल। मुः दाॅभरी व मुः छ्यान्जे या प्रतिवेदन नं अनुमोदन जुल।',
        actDetail8: 'बिद्यान संसोधन प्रस्ताव न पास जुल।',
        actDetail9: 'कचा कचाया व कवया ज्याकुथिंमा  साईनबोर्ड तयगु अनुमोदन जुल।',
        actDetail10: 'नेवाः पाहाॅ छें (NEWA HOMESTAY) अवधारना अनुमोदन जुल।',
        actDetail11: 'WEBSITE दयका छेलीगु  अनुमोदन जुल।',
        actDetail12: 'मुःपाहा   संरक्षक शान्त प्रकाश श्रेष्ठजुनं  School, Jnict व हलिं एगो फाम या बारे न्वचु तया दिल। सभाय्ले मुः दुजःपीं भवानी प्रधान, गोपाल कृष्ण नकर्मी, सुवर्ण मानन्धर, सूर्य लक्ष्मी महर्जन, गौरीशंकर श्रेष्ठ जुन सभाले ब्वती कया दिल।  अथेहे  सूचः व संचार कव कजि राम प्रशाद श्रेष्ठ, मृत्यु व दाहसंस्कार कव कजि विश्व मान श्रेष्ठ जुनं ब्वती कया दिल ।।ज्याझ्वःले विभिन्न कचाया नाय् , केन्द्रिय प्रतिनिधि, दुजपीं व सकल भाजु मयजु पीन्त व ग्वसा खलः यात  शुभाय देछासेः थःगु खः तयधुन्का सभा बिसर्जन याना दिल।',
        actImg1: Img1,
        actImg2: Img2,
        actImg3: '',
    },
];
